import { getSupabaseClient } from "../../atomic-crm/providers/supabase/supabase";

/**
 * Invoke the AI service and surface the SERVER'S error message.
 *
 * supabase-js wraps non-2xx responses in a FunctionsHttpError whose
 * .message is the generic "Edge Function returned a non-2xx status code",
 * hiding the useful text ("This call has no transcript to summarize"). The
 * response body is on error.context; this helper reads it so every AI
 * surface shows the real reason.
 */
export const invokeAi = async <T>(
  body: Record<string, unknown>,
): Promise<{ data: T | null; error: string | null }> => {
  const { data, error } = await getSupabaseClient().functions.invoke(
    "ai-service",
    { body },
  );
  if (!error) return { data: data as T, error: null };

  const context = (error as { context?: Response }).context;
  if (context && typeof context.json === "function") {
    try {
      const payload = (await context.json()) as { error?: string };
      if (payload?.error) return { data: null, error: payload.error };
    } catch {
      // fall through to the generic message
    }
  }
  return {
    data: null,
    error: error.message ?? "The AI service is not reachable",
  };
};
